import React from "react";
import { BsChevronDown } from "react-icons/bs";

const Hero = () => {
  return (
    <section
      style={{
        backgroundImage: "url('/images/OT.jpeg')",
        backgroundColor: "rgb(30, 64, 175)",
        backgroundBlendMode: "overlay"
        // backgroundSize: "130% 100%", // mobile

        // height: "65vh" // mobile
      }}
      className="hero is-link bg-main"
    >
      <div className="hero-body">
        <div>
          <h1 className="title mt-16 lg:mt-28 is-1 hero-title tracking-wide xl:mt-36 2xl:tracking-wider">
            Medicare Hospital
          </h1>
          <p className="subtitle hero-subtitle">Bone and Joint Center</p>
        </div>
      </div>
      <div className="relative m-auto pb-2">
        <p className="text-center pb-1">Learn More</p>
        <BsChevronDown
          className="animate-bounce text-center relative m-auto"
          color="white"
        />
      </div>
    </section>
  );
};

export default Hero;
